import Checkbox from "../../../shared/components/form/Checkbox";
import Modal from "../../../shared/components/Modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function CgvTitle() {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);
    
    return (
        <>
            <div>
                {t('cgv.acceptTerms')}{" "}
                <span
                    className="cursor-pointer text-orange-500 underline"
                    onClick={(e) => {
                        e.preventDefault();
                        setModalOpen(true);
                    }}
                >
                    {t('cgv.seeConditions')}
                </span>
            </div>
            <Modal
                title={t('cgv.cgv')}
                open={modalOpen}
                setOpen={setModalOpen}
            >
                <div className="mx-auto my-4 h-[500px] w-[650px] max-w-full overflow-y-scroll rounded border border-gray-400 bg-gray-100 p-4">
                    <div className="prose prose-sm prose-orange h-full w-full max-w-[600px] text-gray-800">
                        <div className="scrollable-element">
                            <article>
                                <em>{t('cgv.updatedOn')}</em>
                                <h2>
                                    {t('cgv.acceptance')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.relationship')}</p>
                                <ul>
                                    <li>
                                        {t('cgv.company')} <strong>La Malle Postale</strong>
                                        <br />
                                        {t('cgv.sarlInfo')}
                                        <br />
                                        Tel. 04 71 04 21 79 - Tel. 06 44 60 66 87
                                        <br />
                                        contact@lamallepostale.com
                                        <br />
                                        {t('cgv.officeAddress')}
                                        <ul>
                                            <li>
                                                {t('cgv.scheduleFromAprilToOctober')}
                                            </li>
                                            <li>
                                                {t('cgv.scheduleFromOctoberToApril')}
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <strong>{t('cgv.and')}</strong>
                                <ul>
                                    <li>
                                        {t('cgv.the')}{" "}
                                        <strong>
                                            {t('cgv.clientOf')} La Malle Postale
                                        </strong>
                                        .
                                    </li>
                                </ul>
                                <p>{t('cgv.quoteAndReservation')}</p>
                                <p>{t('cgv.generalConditionsPrevail')}</p>
                                <h3>{t('cgv.reservation')}</h3>
                                <p>
                                    <strong>{t('cgv.servicesReservationOnly')}</strong>
                                </p>
                                <p>
                                    <strong>
                                        {t('cgv.servicesCanBeReserved')}{" "}
                                        <a href="http://www.lamallepostale.com">
                                            www.lamallepostale.com
                                        </a>{" "}
                                        {t('cgv.siteOrWebsite')}
                                    </strong>
                                </p>
                                <p>
                                    <strong>{t('cgv.reservationRequested')}</strong>
                                </p>
                                <p>
                                    <strong>
                                        {t('cgv.reservationConfirmedAfterPayment')}
                                        <br />
                                        {t('cgv.paymentBeforeStart')}
                                    </strong>
                                </p>
                                <p>
                                    <strong>{t('cgv.absenceOfConfirmationMail')}</strong>
                                </p>
                                <p>
                                    <strong>{t('cgv.noReservationByPhoneMessage')}</strong>
                                </p>
                                <p>
                                    <strong>
                                        {t('cgv.servicesLimitedByVehiclesAndDrivers')}{" "}
                                        <span className="underline">
                                            {t('cgv.onTheDayOfReservationPayment')}
                                        </span>
                                        .
                                    </strong>
                                </p>
                                <p>
                                    <strong>{t('cgv.contactUsOrFAQ')}</strong>
                                </p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.services')}
                                </h2>
                                <hr className="title-sep" />
                                <h3>{t('cgv.services.insuranceRegulation')}</h3>
                                <p>{t('cgv.services.insuranceInfo')}</p>
                                <p>
                                    {t('cgv.services.transportRegulationInfo')}{" : "}
                                    <a href="https://www.ecologique-solidaire.gouv.fr/acces-et-exercice-profession-transporteur-marchandises-0">
                                        https://www.ecologique-solidaire.gouv.fr/acces-et-exercice-profession-transporteur-marchandises-0
                                    </a>
                                    .
                                </p>
                                <p>{t('cgv.services.paragraph1')}</p>
                                <p>{t('cgv.services.paragraph2')}</p>
                                <h3>{t('cgv.services.transportService')}</h3>
                                <p>{t('cgv.services.paragraph3')}</p>
                                <ul>
                                    <li>{t('cgv.services.returnToStartingPoint')}</li>
                                    <li>{t('cgv.services.transportToNextDestination')}</li>
                                    <li>{t('cgv.services.transportToTrainStation')}</li>
                                </ul>
                                <p>{t('cgv.services.reservationInfo')}</p>
                                <p>{t('cgv.services.luggageInfo')}</p>
                                <p>
                                    {t('cgv.services.transportServiceDog')}
                                    <br />
                                    {t('cgv.services.dogTransportConditions')}
                                </p>
                                <p>{t('cgv.services.shuttleServicePilgrimage')}</p>
                                <ul>
                                    <li>{t('cgv.services.shuttleReturnToStartingPoint')}</li>
                                    <li>{t('cgv.services.shuttleReachVehicle')}</li>
                                </ul>
                                <p>{t('cgv.services.transportServiceBaggageInfo')}</p>
                                <h3>{t('cgv.services.transportServiceBaggageTitle')}</h3>
                                <p>{t('cgv.services.transportServiceBaggage')}</p>
                                <p>{t('cgv.services.baggageReservationInfo')}</p>
                                <p>{t('cgv.services.baggagePickupInfo')}</p>
                                <p>{t('cgv.services.baggageTypes')}</p>
                                <p>
                                    {t('cgv.services.baggageWeightLimit')}
                                    <br />
                                    {t('cgv.services.additionalBaggageFee')}
                                </p>
                                <p>
                                    {t('cgv.services.overweightBaggageInfo')}
                                    <br />
                                    {t('cgv.services.baggageDropOff')}
                                </p>
                                <p>{t('cgv.services.baggageIdentificationInfo')}</p>
                                <ul>
                                    <li>{t('cgv.services.baggageIdentificationMention')}</li>
                                    <li>{t('cgv.services.baggageIdentificationName')}</li>
                                    <li>{t('cgv.services.baggageIdentificationPhone')}</li>
                                    <li>{t('cgv.services.baggageIdentificationNumber')}</li>
                                </ul>
                                <p>
                                    {t('cgv.services.baggageIdentificationLabels')}{" "}(
                                    <a href="https://www.lamallepostale.com/documents/etiquettes-bagages.pdf">
                                        https://www.lamallepostale.com/documents/etiquettes-bagages.pdf
                                    </a>
                                    ).
                                </p>
                                <p>{t('cgv.services.unidentifiedBaggageInfo')}</p>
                                <p>{t('cgv.services.baggageResponsibilityTransport')}</p>
                                <p>{t('cgv.services.baggageValueAndFragileItems')}</p>
                                <p>{t('cgv.services.declarationOfValuableItems')}</p>
                                <p>
                                    {t('cgv.services.baggageTransportWithBikes')}
                                    <br />
                                    {t('cgv.services.bikeTransportReservation')}
                                </p>
                                <h3>{t('cgv.services.vehicleConvoyageService')}</h3>
                                <p>{t('cgv.services.vehicleConvoyageAvailability')}</p>
                                <p>{t('cgv.services.vehicleConvoyageMinimumDistance')}</p>
                                <p>{t('cgv.services.vehicleConvoyageDescription')}</p>
                                <p>{t('cgv.services.vehicleConvoyageContractAndChecklist')}</p>
                                <p>{t('cgv.services.vehicleConvoyageReservation')}</p>
                                <p>{t('cgv.services.vehicleConvoyageInsuranceResponsibility')}</p>
                                <h3>{t('cgv.services.minibusRentalWithoutDriver')}</h3>
                                <p>{t('cgv.services.minibusRentalAvailability')}</p>
                                <p>{t('cgv.services.minibusRentalDescription')}</p>
                                <p>{t('cgv.services.minibusRentalReservation')}</p>
                                <h3>{t('cgv.services.vehicleParking')}</h3>
                                <p>{t('cgv.services.vehicleParkingDescription')}</p>
                                <p>{t('cgv.services.vehicleParkingLocation')}</p>
                                <p>{t('cgv.services.vehicleParkingShuttleReturn')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.zoneReservation.zoneTitle')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.zoneReservation.zoneDescription1')}</p>
                                <p>{t('cgv.zoneReservation.zoneDescription2')}</p>
                                <p>{t('cgv.zoneReservation.zoneDescription3')}</p>
                                <p>
                                    {t('cgv.zoneReservation.routeListDescription')}{" : "}
                                    <a href="https://www.lamallepostale.com/fr/itineraires">
                                        www.lamallepostale.com/fr/itineraires
                                    </a>
                                </p>
                                <p>{t('cgv.zoneReservation.routeDetailsDescription1')}</p>
                                <p>{t('cgv.zoneReservation.routeDetailsDescription2')}</p>
                                <p>{t('cgv.zoneReservation.routeReservationOnlineDescription')}</p>
                                <ul>
                                    <li>
                                        <strong>{t('cgv.zoneReservation.step')} 1</strong>{" : "}{t('cgv.zoneReservation.signInAccount')}
                                    </li>
                                    <li>
                                        <strong>{t('cgv.zoneReservation.step')} 2</strong>{" : "}{t('cgv.zoneReservation.requestQuoteStep1')}
                                    </li>
                                    <li>
                                        <strong>{t('cgv.zoneReservation.step')} 3</strong>{" : "}{t('cgv.zoneReservation.requestQuoteStep2')}
                                    </li>
                                </ul>
                                <p>{t('cgv.zoneReservation.summary')}</p>
                                <p>{t('cgv.zoneReservation.proceedToPayment')}</p>
                                <p>{t('cgv.zoneReservation.acceptance')}</p>
                                <p>{t('cgv.zoneReservation.reservationConfirmationNoPayment')}</p>
                                <p>{t('cgv.zoneReservation.reservationConfirmationWithPayment')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.prices.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>
                                    {t('cgv.prices.paragraph1')}
                                    <br />
                                    {t('cgv.prices.paragraph1.details')}
                                </p>
                                <p>{t('cgv.prices.paragraph2')}</p>
                                <p>{t('cgv.prices.paragraph3')}</p>
                                <p>{t('cgv.prices.paragraph4')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.payment.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.payment.paragraph1')}</p>
                                <p>{t('cgv.payment.paragraph2')}</p>
                                <p>{t('cgv.payment.paragraph3')}</p>
                                <p>
                                    {t('cgv.payment.paragraph4')}
                                    <br />
                                    {t('cgv.payment.paragraph5')}
                                </p>
                                <p>{t('cgv.payment.paragraph6')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.cancellation.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.cancellation.paragraph1')}</p>
                                <p>{t('cgv.cancellation.paragraph2')}</p>
                                <ul>
                                    <li>{t('cgv.cancellation.listitem1')}</li>
                                    <li>{t('cgv.cancellation.listitem2')}</li>
                                    <li>{t('cgv.cancellation.listitem3')}</li>
                                </ul>
                                <p>{t('cgv.cancellation.paragraph3')}</p>
                                <p>{t('cgv.cancellation.paragraph4')}</p>
                                <p>{t('cgv.cancellation.paragraph5')}</p>
                                <ul>
                                    <li>{t('cgv.cancellation.listitem4')}</li>
                                    <li>{t('cgv.cancellation.listitem5')}</li>
                                    <li>{t('cgv.cancellation.listitem6')}</li>
                                </ul>
                                <p>{t('cgv.cancellation.paragraph6')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.forceMajeure.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.forceMajeure.paragraph1')}</p>
                                <p>{t('cgv.forceMajeure.paragraph2')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.loiApplicable.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.loiApplicable.paragraph1')}</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.complaints.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.complaints.paragraph1_1')}{" "}La Malle Postale</p>
                                <p>11 avenue Charles Dupuy, 43000 Le Puy en Velay</p>
                                <p>{t('cgv.complaints.paragraph1_2')}{" "}<strong>04 71 04 21 79</strong>{" "}{t('cgv.complaints.paragraph1_3')}{" "}<strong>contact@lamallepostale.com</strong>.</p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.litiges.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.litiges.paragraph1')}</p>
                                <p>
                                    {t('cgv.litiges.paragraph2')}{" : "}
                                    <a href="https://www.cnpm-mediation-consommation.eu/">
                                        https://www.cnpm-mediation-consommation.eu/
                                    </a>
                                    ,{" "}{t('cgv.litiges.paragraph2_2')}
                                </p>
                                <p>{t('cgv.litiges.paragraph3')}</p>
                                <p>{t('cgv.litiges.paragraph4')}</p>
                                <p>
                                    {t('cgv.litiges.paragraph5')}{" : "}
                                    <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=FR">
                                        https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&amp;lng=FR
                                    </a>
                                </p>
                            </article>
                            <article>
                                <h2 className="part-title">
                                    {t('cgv.dataProtection.title')}
                                </h2>
                                <hr className="title-sep" />
                                <p>{t('cgv.dataProtection.paragraph1')}</p>
                                <p>{t('cgv.dataProtection.paragraph2')}</p>
                                <ul>
                                    <li>{t('cgv.dataProtection.list1item1')}</li>
                                    <li>{t('cgv.dataProtection.list1item2')}</li>
                                    <li>{t('cgv.dataProtection.list1item3')}</li>
                                    <li>{t('cgv.dataProtection.list1item4')}</li>
                                    <li>{t('cgv.dataProtection.list1item5')}</li>
                                    <li>{t('cgv.dataProtection.list1item6')}</li>
                                    <li>{t('cgv.dataProtection.list1item7')}</li>
                                </ul>
                                <p>{t('cgv.dataProtection.paragraph3')}</p>
                                <p>{t('cgv.dataProtection.paragraph4')}</p>
                                <p>{t('cgv.dataProtection.paragraph5')}</p>
                                <p>
                                    Madame Nadine OLLIER,
                                    <br />
                                    {t('cgv.dataProtection.byMail')}{" : "}société La Malle Postale, 11 Avenue
                                    Charles Dupuy 43000 LE PUY EN VELAY
                                    <br />
                                    {t('cgv.dataProtection.byPhone')}{" : "}04.71.04.21.79
                                    <br />
                                    {t('cgv.dataProtection.byEmail')}{" : "}contact@lamallepostale.com
                                </p>
                                <p>{t('cgv.dataProtection.paragraph6')}</p>
                                <p>{t('cgv.dataProtection.paragraph7')}</p>
                            </article>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default function Cgv({ className, onChange }) {
    return (
        <div className={className}>
            <Checkbox onChange={onChange} name="cgv" label={<CgvTitle />} />
        </div>
    );
}
